"use client"

import { useState, useEffect } from "react"
import { Outlet, Navigate, useNavigate, useLocation } from "react-router-dom"
import { useAuth } from "../../../contexts/AuthContext"
import Sidebar from "../../layout/Sidebar"
import TopBar from "../../layout/TopBar"

const Dashboard = () => {
  const { user, loading } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    const allowedPaths = ["/queue", "/campaign-history", "/userprofile"]
    const isAllowed = allowedPaths.some((path) => location.pathname.startsWith(path))
    if (user?.role === "support" && !isAllowed) {
      navigate("/queue", { replace: true })
    }
  }, [user, location.pathname, navigate])

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  const toggleMobileSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  // Redirect to signin if not authenticated
  if (!user) {
    return <Navigate to="/signin" replace />
  }


  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar collapsed={sidebarCollapsed} mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar onToggleSidebar={toggleSidebar} onToggleMobileSidebar={toggleMobileSidebar} />
        <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default Dashboard
